export default __webpack_public_path__ + "static/media/map.cd1c1b27.svg";